import GeofenceApiService from './GeofenceApiService';
import Geofence from './Geofence';

class GeofenceManager {
  googleMap = null;

  isEditingMode = false;

  activeGeofence = null;

  geofences = [];

  geofenceApiService = new GeofenceApiService();

  onActiveGeofenceChange = null;

  constructor(googleMap) {
    this.googleMap = googleMap;
    this._registerEventListeners();
  }

  enterEditMode = () => {
    this.isEditingMode = true;
  }

  exitEditMode = () => {
    this.isEditingMode = false;
    this._setActiveGeofence(null);

    // Re render the geofences from memory since its possible we may have
    // edited them on the screen and not saved them.
    this._renderGeofences();
  }

  reloadGeofences = () => {
    this.geofences.forEach((geofence) => {
      geofence.destroy();
    });

    return this.geofenceApiService.list().then((geofencesJson) => {
      this.geofences = geofencesJson.map(payload => this._createGeofence(payload));
    });
  }

  saveActiveGeofence(params) {
    if (!this.activeGeofence) {
      return Promise.resolve();
    }

    const { activeGeofence } = this;

    const payload = {
      ...params,
      id: activeGeofence.id,
      geom: activeGeofence.getLiveGeoJson(),
    };

    return this.geofenceApiService.save(payload)
      .then(() => {
        this._setActiveGeofence(null);
        return this.reloadGeofences();
      });
  }

  deleteActiveGeofence() {
    if (!this.activeGeofence) {
      return Promise.resolve();
    }

    const { activeGeofence } = this;

    if (activeGeofence.persisted) {
      return this.geofenceApiService.delete(activeGeofence.id)
        .then(() => {
          this._setActiveGeofence(null);
          return this.reloadGeofences();
        });
    }

    // If we were trying to delete a geofence that had not been saved
    return Promise.resolve();
  }

  _setActiveGeofence = (geofence) => {
    if (this.activeGeofence === geofence) {
      // No change
      return;
    }

    if (this.activeGeofence) {
      // Disable the old
      this.activeGeofence.setActive(false);

      if (!this.activeGeofence.persisted) {
        // And discard (remove from map) it if unsaved
        this.activeGeofence.destroy();
      }
    }

    if (geofence) {
      geofence.setActive(true);
    }
    this.activeGeofence = geofence;

    this.onActiveGeofenceChange(geofence);
  }

  _registerEventListeners = () => {
    // Register geofence add click handler
    this.googleMap.addListener('click', (e) => {
      if (!this.isEditingMode) {
        return;
      }

      if (!this.activeGeofence) {
        this._setActiveGeofence(this._createGeofence());
      }

      this.activeGeofence.addVertex(e.latLng);

      // Force event to fire to listeners
      this.onActiveGeofenceChange(this.activeGeofence);
    });
  }

  _createGeofence = (payload) => {
    const newGeofence = new Geofence(payload);

    newGeofence.onClick = this._onGeofenceClick(newGeofence);
    newGeofence.onDelete = this.deleteActiveGeofence;
    newGeofence.onVertexDeleted = this._onGeofenceVertexDeleted;

    newGeofence.render(this.googleMap);

    return newGeofence;
  }

  _onGeofenceClick = geofence => () => {
    if (!this.isEditingMode) {
      return;
    }

    if (!this.activeGeofence) {
      this._setActiveGeofence(geofence);
    }
  }

  _onGeofenceVertexDeleted = () => {
    // Force update the DOM so that GeofenceEditorActionSheet rerenders and calls geofence.isValid?
    // bubble up?
  }

  _renderGeofences = () => {
    this.geofences.forEach((geofence) => {
      geofence.render(this.googleMap);
    });
  }
}

export default GeofenceManager;
